import { render, staticRenderFns } from "./MapTypes.vue?vue&type=template&id=6885740a&scoped=true"
import script from "./MapTypes.vue?vue&type=script&lang=js"
export * from "./MapTypes.vue?vue&type=script&lang=js"
import style0 from "./MapTypes.vue?vue&type=style&index=0&id=6885740a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6885740a",
  null
  
)

export default component.exports